function initProjectQHeader(root = document) {
  const menus = [...root.querySelectorAll('[data-pq-mega]')];
  const closeOthers = (current) => menus.forEach((menu) => {
    if (menu !== current) menu.open = false;
  });

  menus.forEach((menu) => {
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      closeOthers(menu);
      menu.open = true;
    };
    const close = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        menu.open = false;
      }, 120);
    };

    menu.addEventListener('pointerenter', open);
    menu.addEventListener('pointerleave', close);
    menu.addEventListener('focusin', open);
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) close();
    });
  });

  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    menus.forEach((menu) => {
      menu.open = false;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initProjectQHeader());
